'use client';

import { css } from '@bts-web/utils-style-engine';
import {
  intlFiatValueFormatting,
  MaximumFractionDigits,
} from '@bts-web/utils-formatting';
import { OpenDrawerFunction } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useIsBelowScreenWidth } from '../../../layouts/utils/useIsBelowScreenWidth';
import {
  SmallIconMapper,
  TradeAssetSelectorTranslations,
} from '../../ChangeCurrencyOrSwap/changeCurrencyUtils';
import { FiatWalletDetailsDrawer } from './FiatWalletDetailsDrawer';
import { PaymentMethodRow, sectionLabelStyles } from './PaymentMethodRow';

export const WalletCell = ({
  walletAmount,
  currency,
  locale,
  translations,
  openDrawer,
}: {
  walletAmount: string;
  locale: string;
  currency: string;
  translations: TradeAssetSelectorTranslations;
  openDrawer: OpenDrawerFunction;
}) => {
  const valueFormatted = intlFiatValueFormatting(walletAmount, {
    locale,
    currency,
    fractionDigits: MaximumFractionDigits.FIAT,
  });

  const isMobile = useIsBelowScreenWidth(1024);

  const handleWalletDetails = () => {
    openDrawer(FiatWalletDetailsDrawer, {
      currency,
      locale,
      walletAmount,
      position: isMobile ? 'bottom' : 'right',
    });
  };

  return (
    <div
      data-testid="buy-source-fiat-wallet"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'extra_small',
        paddingBottom: 'medium',
        borderBottom: '1px solid',
        borderBottomColor: 'neutrals.divider',
        width: '100%',
      })}
    >
      <span className={sectionLabelStyles}>{translations.paymentMethod}</span>

      <PaymentMethodRow
        icon={SmallIconMapper[currency as keyof typeof SmallIconMapper]}
        name={translations.fiatWalletLabel}
        amount={valueFormatted}
        onClick={handleWalletDetails}
      />
    </div>
  );
};
